import urlPatterns from "../urls";
import { getGuestSubscriptionCheckout } from "./guestSubscriptionCheckout";

// Login may reload after storing tokens, losing its in-memory route state. The
// pending checkout is the durable return destination until reconciliation ends.
export const getGuestCheckoutLoginRedirect = (redirectUrl: string, hasQuizData = false): string => {
  const path = redirectUrl.split(/[?#]/)[0];
  const isQuizDestination = [urlPatterns.QUIZ_RESULTS, urlPatterns.IN_STORE_QUIZ_RESULTS].includes(path);
  if (hasQuizData || isQuizDestination) return redirectUrl;
  return getGuestSubscriptionCheckout() ? urlPatterns.CHECKOUT : redirectUrl;
};
